(function() {
  var onePageMenu = {
    init: function(classSelected, topDistance) {
      var menuBoxes = [];
      var isHashUrl = false;
      var currentBox = null;

      var setMenuBoxes = function() {
        $('[data-menu-href]').each(function() {
          menuBoxes.push($(this));
        });
      }

      var setSelectedMenu = function() {
        for (var i = 0; i < menuBoxes.length; i++) {
          if (menuBoxes[i].offset().top - topDistance < $(window).scrollTop()
              && menuBoxes[i].offset().top + menuBoxes[i].innerHeight() - topDistance > $(window).scrollTop()
              && currentBox !== menuBoxes[i].data('menuHref')) {
            selectMenu(menuBoxes[i].data('menuHref'));
            currentBox = menuBoxes[i].data('menuHref');
          }
        }
      }

      var selectMenu = function(current) {
        $('.x-menu-onepage li').removeClass(classSelected);
        $('.x-menu-onepage li a[href="#'+ current +'"]').parent().addClass(classSelected);
      }

      var moveToMenu = function(objLink) {
        if (typeof(objLink) === 'object') {
          var hashLink = objLink.attr('href').slice(1);
        } else {
          var hashLink = objLink.slice(1);
        }

        var menuBox = $('[data-menu-href="' + hashLink + '"]');
        if (menuBox.length > 0) {
          $('html, body').stop(true, false).animate({ scrollTop: (menuBox.offset().top - topDistance) }, 800, function() {
            document.location.hash = hashLink;
            selectMenu(hashLink);
          });
        } else {
          $('html, body').stop(true, false).animate({ scrollTop: 0 }, 800);
          history.pushState('', document.title, window.location.pathname);
          selectMenu(hashLink);
        }
      }

      window.addEventListener('scroll', function() {
        setSelectedMenu();
      });

      $(document).ready(function() {
        setMenuBoxes();
        if (document.location.hash !== '') { isHashUrl = true; }

        $('.x-one-page').click(function(e) {
          e.preventDefault();
          moveToMenu($(this));
        });
      });

      window.addEventListener('load', function() {
        if (isHashUrl) { moveToMenu(document.location.hash); }
      });
    }
  };

  $(document).ready(function() {
    if ($('.x-menu-onepage').length > 0) { onePageMenu.init('menu-side__element--selected', 100); }
  });
})();
